import { connect } from 'react-redux';
import { selectors as staffSelectors } from 'ducks/staff';
import ProductLookup from './ProductLookup';
import React from 'react';
import { IProductLookupProps } from './ProductLookup.properties';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';

const mapStateToProps = (state) => ({
    DefaultWarehouse: staffSelectors.staff(state)?.defaultWarehouseEntity
});

const ConnectedComponent = connect(mapStateToProps, null)((props: Readonly<IProductLookupProps>) => {
    return (<ProductLookup
        {...props} />);
});

export default React.forwardRef(
    (props: Readonly<IProductLookupProps>, ref: React.Ref<IBasicLookupFieldHandle>) => {

        return <ConnectedComponent {...props} fieldRef={ref} />;
    });
